import {itemAPI} from '../../services/ItemServices';
import {productTypesAPI} from "../../services/ProductTypeServices";

export function getAllItemsV2() {
    const {
        data: items,
        error: getAllItemsError,
        isLoading: getAllItemsIsLoading,
        isSuccess: getAllItemsIsSuccess
    } = itemAPI.useGetAllItemsV2Query();

    return {items, getAllItemsIsLoading, getAllItemsError, getAllItemsIsSuccess};
}

export function getAllProductTypesForRecipes() {
    const {
        data: productTypes,
        isLoading: isLoadingProductTypes,
        error: getProductTypesError,
        isSuccess: isSuccessProductTypes
    } = productTypesAPI.useGetProductTypesV2AllLightQuery();

    return {
        productTypes, isLoadingProductTypes, getProductTypesError, isSuccessProductTypes
    };
}
